export default "__VITE_ASSET__DUET4g6S__ 640w, __VITE_ASSET__BKpbhlF4__ 1024w, __VITE_ASSET__DzKcbF7r__ 1280w";